import { HttpHelper } from '@helpers/http.helper';

export interface ConsistencyCheckJson {
  id: number;
  account_number: string;
  label: string;
  total_module: number;
  total_accounting: number;
}

export class ConsistencyCheck {
  public readonly difference: number;
  public readonly valid: boolean;

  constructor(
    public readonly id: number,
    public readonly accountNumber: string,
    public readonly label: string,
    public readonly totalModule: number,
    public readonly totalAccounting: number
  ) {
    this.difference = (this.totalModule ?? 0) - (this.totalAccounting ?? 0);
    this.valid = this.difference === 0;
  }

  static fromJson(json: Partial<ConsistencyCheckJson>): ConsistencyCheck {
    return new ConsistencyCheck(json.id, json.account_number, json.label, json.total_module, json.total_accounting);
  }

  static toJson(model: ConsistencyCheck): ConsistencyCheckJson {
    return {
      id: model.id ?? undefined,
      account_number: HttpHelper.toJsonProperty(model.accountNumber),
      label: HttpHelper.toJsonProperty(model.label),
      total_module: HttpHelper.toJsonProperty(model.totalModule),
      total_accounting: HttpHelper.toJsonProperty(model.totalAccounting)
    };
  }
}
